import { Link, Navigate, useRouteLoaderData } from "react-router-dom";
import {
  isFreeOrganizationAccount,
  Organization,
} from "../../services/organization/organizationModel";
import { useTranslation } from "react-i18next";
import { User, getGuideLink } from "../../services/user/userModel";
import { useMemo } from "react";
import IconGuide from "../../assets/icons/icon-guide-white.svg";

const OrganizationDashboardPage = () => {
  const { t } = useTranslation(["organization", "common"]);
  const { organization } = useRouteLoaderData("organization") as {
    organization: Organization;
  };
  const { loggedUser } = useRouteLoaderData("logged-user") as {
    loggedUser?: User;
  };

  const invitation = useMemo(() => {
    return loggedUser?.invitations?.[0] ?? null;
  }, [loggedUser]);
  const isValidInvitation = useMemo(() => {
    return (invitation?.organization?.subscriptions?.length ?? 0) > 0;
  }, [invitation]);
  const guideLink = useMemo(
    () => getGuideLink(loggedUser?.usage),
    [loggedUser?.usage],
  );
  const isFreeAccount = useMemo(
    () => isFreeOrganizationAccount(organization, loggedUser),
    [organization, loggedUser],
  );

  // Free pro accounts have no dashboard: everything happens on "my candidates"
  if (isFreeAccount) return <Navigate to="/organization/candidates" replace />;

  return (
    <div className="layout_content --bg--organization-dashboard">
      <div className="page-content container --wrap">
        <h1 className="page_title">
          {t("organization:dashboard.WELCOME_RECRUITER_DASHBOARD")}
        </h1>

        {!isValidInvitation &&
          (organization.subscriptions ?? []).length === 0 && (
            <div className="lblock info --warning">
              {t("organization:dashboard.NO_SUBSCRIPTION")}{" "}
              <Link className="link --underlined" to="pro/subscription">
                {t("organization:dashboard.SUBSCRIBE")}
              </Link>
            </div>
          )}
        {/* {!organization.stripeCustomer && (
          <div className="lblock info --warning">
            {t("organization:dashboard.NO_PAYMENT_METHOD")}{" "}
            <Link className="link --underlined" to="pro/subscription">
              {t("organization:dashboard.REGISTER_PAYMENT_METHOD")}
            </Link>
          </div>
        )} */}
        {invitation &&
          (isValidInvitation ? (
            <div className="lblock info --success">
              {t("organization:subscription.INVITATION_VALID_SUB_DESCRIPTION", {
                replace: {
                  pro: invitation.organization?.legalName,
                },
              })}
            </div>
          ) : (
            <div className="lblock info --warning">
              {t(
                "organization:subscription.INVITATION_EXPIRED_SUB_DESCRIPTION",
                {
                  replace: {
                    pro: invitation.organization?.legalName,
                  },
                },
              )}
            </div>
          ))}
        {organization && !loggedUser?.adminOrga && (
          <div className="lblock info --success">
            {t("organization:MEMBER_OF_ORGANIZATION", {
              replace: {
                pro: organization.legalName,
              },
            })}
          </div>
        )}

        <div className="organisation-dashboard_tiles">
          <Link to="candidates" className="dashboard_tile --orange">
            <canvas className="tile_img --candidates" />
            <h2 className="tile_title">
              {t("organization:dashboard.MY_CANDIDATES")}
            </h2>
          </Link>
          {!isFreeAccount && (
            <Link to="capsules" className="dashboard_tile --blue">
              <canvas className="tile_img --capsules" />
              <h2 className="tile_title">
                {t("organization:dashboard.MY_JOB_POSTINGS")}
              </h2>
            </Link>
          )}
          {!isFreeAccount && guideLink && (
            <a
              href={guideLink}
              className="dashboard_tile --blue --guide-alt"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={IconGuide}
                alt={t("common:header.RECRUITER_GUIDE")}
                className="tile_illustration"
              />
              <h2 className="tile_title">
                {t("common:header.RECRUITER_GUIDE")}
              </h2>
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrganizationDashboardPage;
